<sh-control *ngIf="control" [control]="this">
  <ejs-checkbox
    [formControl]="control"
    [label]="placeholder"
    [id]="formControlName"
    [attr.name]="formControlName"
  ></ejs-checkbox>
</sh-control>
